var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGuard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B",
  d: "M9 12.067v9.8c0 .6.4 2.2 1.6 4 .4.7 1 1.4 1.7 2.1 1.6 1.6 3.8 3.2 7 4.3 9.5-4 9.8-10.4 9.8-10.4v-9.8c-.3 0-.6.1-.9.1-1.3.1-2.5 0-3.6-.2-3.7-.7-5.5-2.7-5.5-2.7s-3.5 3.6-10.1 2.8Z"
})));
export default SvgGuard;